import axiosClient from "../../network";

export default class Maintenance {
  static getMaintenanceStatus(params) {
    return axiosClient
      .get("webStatus", {
        params
      })
      .then((data) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}
